// extracted by mini-css-extract-plugin
export var actionText = "_mp-4";
export var container = "_mp-0";
export var leftSection = "_mp-1";
export var rightSection = "_mp-2";
export var settingsButton = "_mp-6";
export var settingsIcon = "_mp-7";
export var shortcut = "_mp-5";
export var shortcutGroup = "_mp-3";